export const INFO_NOT_AVAILABLE = '-'
export const INFO_NOT_AVAILABLE_NA = 'N/A'
